var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecorderDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 19,
    fill: "none",
    viewBox: "0 0 11 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.60061 0H5.39939C3.85671 0 2.58232 1.50773 2.58232 3.33288V8.1338C2.58232 9.95895 3.85671 11.4667 5.39939 11.4667H5.60061C7.1433 11.4667 8.41769 9.95895 8.41769 8.1338V3.33288C8.41769 1.50773 7.1433 0 5.60061 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 8.17342C11 7.73698 10.6982 7.37988 10.3293 7.37988C9.96037 7.37988 9.65854 7.73698 9.65854 8.17342C9.65854 10.9111 7.78049 13.0934 5.5 13.0934C3.21951 13.0934 1.34146 10.9111 1.34146 8.17342C1.34146 7.73698 1.03963 7.37988 0.670732 7.37988C0.301829 7.37988 0 7.73698 0 8.17342C0 11.5063 2.1128 14.244 4.82927 14.6011V17.0611H3.32012C2.95122 17.0611 2.64939 17.4182 2.64939 17.8546C2.64939 18.2911 2.95122 18.6482 3.32012 18.6482H7.64634C8.01524 18.6482 8.31707 18.2911 8.31707 17.8546C8.31707 17.4182 8.01524 17.0611 7.64634 17.0611H6.17073V14.6011C8.88719 14.244 11 11.5063 11 8.17342Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorderDefault);
export default __webpack_public_path__ + "static/media/recorder_default.39542b327fb979eb9569c7caf992bd74.svg";
export { ForwardRef as ReactComponent };